import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { ResourceLock } from './resource-lock'

export class ResourcesLockRepository extends BaseRepository<ResourceLock> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.schedulerApi + '/resources-lock', token, cache)
    }

    async resourcesLocked(from: Date, to: Date) {
        // ISO: o toString() de Date põe espaço, parênteses e o nome do fuso (com acento) na URL
        const { json, statusCode, message } = await this.request.get(
            this.config.schedulerApi +
                '/resources-lock/locked?from=' +
                encodeURIComponent(new Date(from).toISOString()) +
                '&to=' +
                encodeURIComponent(new Date(to).toISOString()) +
                '&token=' +
                this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
